import { baseApi } from "../baseApi";

export const projectApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getProjectList: builder.query({
      query: (paramsData) => ({
        url: `/api/resource/Project`,
        params:JSON.stringify(paramsData)
      }),
    }),
  }),
});

export const { useGetProjectListQuery } = projectApi;
